import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    AccountGridContainer,
    AccountNameGrid,
    AccountNumberDesktopGrid,
    MoreContainer,
    DistrictGrid,
    CityGrid,
    DesktopView,
    MobileView,
    PaginationContainer,
    PaginationContainerMobile,
    SearchBoxContainer,
    AccountPaginationWrapper,
    DitrictNameContainer,
    TerritoryNameContainer,
    ProductGuideListContainer,
    ProductGuideListContainerHeader,
    HeaderContainer,
    HeaderTextContainer,
    MainWrapper,
} from './associatedAccountCard.styled';
import {
    setShowUnsaved,
    getAccountDetailss,
    setShowPopup,
    setSelectedAccount,
    closeAccountPopUP,
    setPopupCloseFromHeader,
    setCommonCancel,
} from 'src/pages/more/redux/actions';
import { AccountDetailsContainer } from 'src/pages/more/pages/accounts/components/accountList/index.styled.jsx';
import AccountDetails from 'src/pages/more/pages/accounts/components/AccountDetails/index.jsx';
import { getAdminAccountDetails } from 'src/pages/admin/redux/action/index.js';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import SearchBox from 'src/common/refactoredComponents/searchbox/index';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { useTranslation } from 'react-i18next';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const AssociatedAccount = (props) => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState('');
    const [selectedIndex, setselectedIndex] = useState(false);
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [, setIsEnter] = useState(false);
    const [accountDetail] = useState({});
    const { t } = useTranslation();
    const associatedAccount = useSelector(
        (state) => state.AdminReducer.associatedAccount
    );
    const isEditCheck = useSelector((state) => state.accountReducer.isEdit);
    const shipToAddressEdit = useSelector(
        (state) => state.accountReducer.shipToAddressEdit
    );
    const totalAssociatedAccount = useSelector(
        (state) => state.AdminReducer.totalAssociatedAccount
    );
    const commonUnsavedchanges = useSelector(
        (state) => state.accountReducer.commonUnsavedchanges
    );
    const selectedAccount = useSelector(
        (state) => state.accountReducer.selectedAccount
    );
    const showPopup = useSelector((state) => state.accountReducer.showPopup); 
    const loading = useSelector(
        (state) => state.AdminReducer.associatedAccountStatus
    );
    const updateSearch = (val) => {
        setIsEnter(false);
        setSearchValue(val);
        let param = {
            searchAccountParam: val,
            principalUser: props.userData.networkIdName,
        };

        dispatch(getAdminAccountDetails(param));
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.target.blur();
            // dispatch(searchProducts({ searchTerm: event.target.value }));
            setIsEnter(true);
            let param = {
                searchAccountParam: searchValue && searchValue.trim(),
                principalUser: props.userData.networkIdName,
            };

            dispatch(getAdminAccountDetails(param));
        }
    };
    useEffectWithErrorLogging(() => {
        const param = {
            pageNum: page,
            principalUser: props.userData.networkIdName,
            searchAccountParam: searchValue !== '' ? searchValue : '',
        };

        dispatch(getAdminAccountDetails(param));
    }, [page]);

    const openAccountDetails = (account) => {
        dispatch(setSelectedAccount(account));
        dispatch(setShowPopup(true));
        dispatch(getAccountDetailss({ accountId: account.accountId }));
    };
    const closeAccountDetails = () => {
        dispatch(setPopupCloseFromHeader(true));
        if (isEditCheck || shipToAddressEdit) {
            dispatch(setCommonCancel(true));
        } else if (commonUnsavedchanges) {
            dispatch(setShowUnsaved(true));
        } else {
            dispatch(setShowPopup(false));
            dispatch(closeAccountPopUP(true));
        }
    };

    const handleClearSearch = () => {
        //if (isEnter) {
        setPage(0);
        setFirst(0);
        const param = {
            pageNum: page,
            principalUser: props.userData.networkIdName,
        };
        dispatch(getAdminAccountDetails(param));
        //}
    };
    const handleClick = (value) => {
        setselectedIndex(value);
    };
    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
    };
    return (
        <>
            <ProductGuideListContainerHeader>
                <SearchBoxContainer style={{ marginLeft: '0px' }}>
                    <SearchBox
                        id="admin-nameDetails-associatedAccountCard-searchbox"
                        updateSearch={updateSearch}
                        searchProduct={searchValue}
                        placeholder={t('admin.adminList.search')}
                        width={'345px'}
                        containerMobileWidth={'345px'}
                        height={'40px'}
                        borderRadius={'20px'}
                        paddingLeft={'2.2rem'}
                        isSearchIcon={true}
                        searchIconWidth={'min-content'}
                        fontSize={'14px'}
                        handleKeyPress={handleKeyPress}
                        clearSearch={handleClearSearch}
                        background={'none'}
                        enterkeyhint={'go'}
                        borderLeft={'none'}
                    />
                </SearchBoxContainer>
                <HeaderContainer
                    container
                    justifyContent={'space-between'}
                    direction="row"
                >
                    <HeaderTextContainer
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        mobile={12}
                    >
                        {t('accounts.accountList.accountName')}
                    </HeaderTextContainer>
                    <HeaderTextContainer
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        mobile={12}
                        deskPadding={'0 30px'}
                        ipadPadding={'0 16px'}
                    >
                        {t('accounts.accountList.districtTerritory')}
                    </HeaderTextContainer>
                </HeaderContainer>
            </ProductGuideListContainerHeader>
            <MainWrapper>
                {loading === true ? (
                    // <Spinner animation="border" variant="primary"></Spinner>
                    // <Backdrop
                    //     showCloseButton={false}
                    //     showBackdrop={true}
                    //     isModal
                    //     loaderBackground
                    // >
                    <Spinner
                        id="admin-associatedAccountCard-nameDetails-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                ) : // </Backdrop>
                null}{' '}
                {associatedAccount &&
                    associatedAccount.map((physician, index) => {
                        physician.showMore =
                            selectedIndex === index ? true : false;

                        const initAddr = physician.districtAndTerritory.slice(
                            0,
                            2
                        );
                        const finalAddr =
                            physician.districtAndTerritory.slice(2);

                        return (
                            <ProductGuideListContainer key={index}>
                                <AccountGridContainer
                                    id={`admin-associatedAccountCard-row-${index}`}
                                    container
                                    justifyContent={'space-between'}
                                    direction="row"
                                    onClick={() =>
                                        openAccountDetails(physician)
                                    }
                                >
                                    <AccountNameGrid
                                        item
                                        xs={12}
                                        sm={5}
                                        md={5}
                                        lg={5}
                                        xl={5}
                                        mobile={8}
                                    >
                                        <span
                                            style={{ display: 'inline-flex' }}
                                        >
                                            <a className="admin-account-dt-mask"
                                                style={{
                                                    marginRight: '40px',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {physician.accountName}
                                            </a>
                                        </span>
                                        <AccountNumberDesktopGrid>
                                            <span
                                                style={{
                                                    fontSize: '14px',
                                                    letterSpacing: '-0.11px',
                                                }}
                                            >
                                                {t(
                                                    'accounts.accountDetailHeader.account'
                                                )}{' '}
                                            </span>
                                            <span className="admin-account-dt-mask">{accountNumberZeroTrimmer(
                                                physician.accountId
                                            )}</span>
                                        </AccountNumberDesktopGrid>
                                        <CityGrid>
                                            <span className="admin-account-address-dt-mask">{physician.address.city}</span>,{' '}
                                            <span className="admin-account-address-dt-mask">{physician.address.state}</span>
                                        </CityGrid>
                                    </AccountNameGrid>
                                    <DistrictGrid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={6}
                                        lg={6}
                                        xl={6}
                                        mobile={12}
                                    >
                                        {initAddr.map((address, index) => {
                                            // let addressArray = address.split(',');

                                            return (
                                                <div
                                                    style={{ display: 'block' }}
                                                    key={index}
                                                >
                                                    <DitrictNameContainer>
                                                        {address.district}{' '}
                                                        {address.districtCode}
                                                    </DitrictNameContainer>
                                                    {'  •  '}

                                                    <TerritoryNameContainer>
                                                        {address.territory}{' '}
                                                        {address.territoryCode}
                                                    </TerritoryNameContainer>
                                                </div>
                                            );
                                        })}
                                        {physician.districtAndTerritory.length >
                                            2 &&
                                            physician.showMore === false && (
                                                <MoreContainer
                                                    id={`admin-associatedAccountCard-moreButton-${index}`}
                                                    onClick={() =>
                                                        handleClick(index)
                                                    }
                                                >
                                                    {`+${
                                                        physician
                                                            .districtAndTerritory
                                                            .length - 2
                                                    } ${t('common.moreLabel')}`}
                                                </MoreContainer>
                                            )}
                                        {physician.showMore === true &&
                                            finalAddr.length > 0 &&
                                            finalAddr.map((address, index) => {
                                                return (
                                                    <div
                                                        style={{
                                                            display: 'block',
                                                        }}
                                                        key={index}
                                                    >
                                                        <DitrictNameContainer>
                                                            {address.district}{' '}
                                                            {
                                                                address.districtCode
                                                            }
                                                        </DitrictNameContainer>
                                                        {'  •  '}

                                                        <TerritoryNameContainer>
                                                            {address.territory}{' '}
                                                            {
                                                                address.territoryCode
                                                            }
                                                        </TerritoryNameContainer>
                                                    </div>
                                                );
                                            })}
                                    </DistrictGrid>

                                    {/* <DistrictGrid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    xl={6}
                                    mobile={12}
                                >
                                    <div
                                        style={{
                                            display: 'block',
                                        }}
                                    >
                                        <DitrictNameContainer>
                                        {physician.accountId}
                                            DSM WESTERN CALROLINA 373
                                        </DitrictNameContainer>
                                        {'  •  '}

                                        <TerritoryNameContainer>
                                            MARY / OPEN 456
                                        </TerritoryNameContainer>
                                    </div>
                                    <div
                                        style={{
                                            display: 'block',
                                        }}
                                    >
                                        <DitrictNameContainer>
                                            MIDATLANTIC 327
                                        </DitrictNameContainer>
                                        {'  •  '}

                                        <TerritoryNameContainer>
                                            JEFFREY A KELLEY 489
                                        </TerritoryNameContainer>
                                    </div>
                                    <MoreContainer>+1 more</MoreContainer>
                                </DistrictGrid> */}
                                </AccountGridContainer>
                            </ProductGuideListContainer>
                        );
                    })}
            </MainWrapper>
            <AccountPaginationWrapper>
                <DesktopView className="account-pagination-wrapper">
                    <PaginationContainer>
                        <BasicPagination
                            margin="12px 0px"
                            content={t(
                                'accounts.accountSearchBox.accountSearchResult.showingAccounts'
                            )}
                            iPadPaginatorInfoWidth={'100%'}
                            iPadPaginatorWidth={'100%'}
                            totalRecords={totalAssociatedAccount || 0}
                            recordsFetched={
                                associatedAccount && associatedAccount.length
                            }
                            pageNumber={page}
                            handleChange={(e) => onPageChange(e)}
                            first={first}
                        />
                    </PaginationContainer>
                </DesktopView>
                <MobileView className="mobile-pagination-wrapper">
                    <PaginationContainerMobile padding={'15px'}>
                        <BasicPagination
                            mobilePadding={'2% 2% 2% 2%'}
                            content={t(
                                'accounts.accountSearchBox.accountSearchResult.showingAccounts'
                            )}
                            totalRecords={totalAssociatedAccount || 0}
                            recordsFetched={
                                associatedAccount && associatedAccount.length
                            }
                            pageNumber={page}
                            handleChange={(e) => onPageChange(e)}
                            first={first}
                        />
                    </PaginationContainerMobile>
                </MobileView>
            </AccountPaginationWrapper>
            {showPopup && (
                <ModalDialog
                    modalHeight={'calc(100vh - 130px)'}
                    modalWidth={'70%'}
                    smalModalWidth={'85%'}
                    left={'7%'}
                    right={'7%'}
                    bottom={'10%'}
                    padding={'0px'}
                    top={'8%'}
                    handleClose={() => closeAccountDetails()}
                    // isIPadPotrait={true}
                    zIndex={'2000'}
                    marginTop={'30%'}
                    style={{ backgroundColor: '#fff' }}

                    //     modalHeight={'450px'}
                    //     marginTop={'32%'}
                    //     overflowX={'hidden'}
                    //     maxWidth={'760px'}
                    //     handleClose={closeAccountDetails}
                    //     zIndex={dialogZindex}
                    //     // paddingBottom={'110px'}
                    //     padding={'16px 3px 16px 16px'}
                    //     isIPadPotrait={true}
                    //     afterSubmitTemplate={false}
                    //     popoverId={accountDetailsPopoverId}
                    //     showPopOver={showAccountDetails}
                    //     AnchorEl={true}
                    //     // handleClose={handleSearchClose}
                    //     top={'130px'}
                >
                    <AccountDetailsContainer>
                        <AccountDetails
                            selectedAccount={selectedAccount}
                            accountDetail={accountDetail}
                            handleClose={closeAccountDetails}
                            isFromPhysician={props.isFromPhysician}
                            fromSearch={props.fromSearch}
                            employeeRole={props.employeeRole}
                            isFromAdmin={true}
                        />
                    </AccountDetailsContainer>
                </ModalDialog>
            )}
        </>
    );
};
export default AssociatedAccount;
